import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {QuotationService} from "../../../../services/quotation-service/quotation.service";
import {ValidationService} from "../../../../services/validation-service/validation.service";

declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-license-details',
  templateUrl: './license-details.component.html'
})
export class LicenseDetailsComponent implements OnInit {

  constructor(public router: Router,
              public quotationService: QuotationService,
              public validationService: ValidationService) { }

  ngOnInit() {
    this.reloadJCF();
  }

  private reloadJCF() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  get licenseIssueYears() {
    return Array.from({ length: 101 }, (_, i) => new Date().getFullYear() - i);
  }

}

